import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { AppConfigService } from 'src/app/app-config.service';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BehaviorSubject<any[]> {
  readonly cryptoKey = 'msra';
  config: any = this.appConfig.getConfig();
  apiUrl = this.config !== undefined ? this.config.API_URL : '';

  constructor(private httpClient: HttpClient, protected appConfig: AppConfigService,
    private usersService: UsersService) {
    super([]);
  }

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  getUserOrganizations(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_ACCOUNT_ORGS_ENDPOINT;
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(url, obj, { headers: reqHeader })
      .pipe(map((response: any) => response as any),
        catchError(this.handleError));
  }

  getChangePasswordEndpoint(currentPassword, newPassword): Observable<any> {
    const url = this.apiUrl + Global.BASE_ACCOUNT_CHANGEPASSWORD_ENDPOINT;
    const userEdit = {
      currentPassword: this.usersService.encrypt(currentPassword, 'post'),
      newPassword: this.usersService.encrypt(newPassword, 'post'),
      userInfo: this.UserInfo()
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const data = JSON.stringify(userEdit);
    return this.httpClient.post<any>(url, data, httpOptions)
      .pipe(map((response: any) => response));
  }

  isPwdUsed(password: any): Observable<any> {
    const inputData = {
      userInfo: this.UserInfo(), password
    };
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const url = this.apiUrl + Global.BASE_PASSWORD_EXISTS_ENDPOINT;
    return this.httpClient.post<any>(url, inputData, { headers: reqHeader })
      .pipe(map((response: any) => response),
        catchError(err => this.handleError(err)));
  }

  encrypt(msg: any, type: any): any {
    // random salt for derivation
    const keySize = 256;
    const salt = CryptoJS.lib.WordArray.random(16);
    // well known algorithm to generate key
    const key = CryptoJS.PBKDF2(this.cryptoKey, salt, {
      keySize: keySize / 32,
      iterations: 100
    });
    // random IV
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    // specify everything explicitly
    const encrypted = CryptoJS.AES.encrypt(msg, key, {
      iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    // combine everything together in base64 string
    const result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
    const encodedVal = encodeURIComponent(result);
    return type === 'post' ? result : encodedVal;
  }

  decryptData(encryptData: any, passPhrase: any): any {
    const key = CryptoJS.enc.Utf8.parse(passPhrase);
    const iv = CryptoJS.enc.Utf8.parse(passPhrase);
    const decrypted = CryptoJS.AES.decrypt(encryptData, key,
      {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  private handleError(error: Response) {
    const response: any = {
      success: false,
      message: Global.DisplayErrorMessage
    };
    return throwError(response);
  }
}
